import { useAuth } from "@/context/AuthContext";

const EMERGENT_AUTH_URL = "https://auth.emergentagent.com/";

export default function AdminLogin() {
  const { user, loading } = useAuth();

  const goLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/leads";
    window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return (
      <div className="admin-shell">
        <div className="admin-loading">Checking session…</div>
      </div>
    );
  }

  return (
    <div className="admin-shell admin-login-shell">
      <div className="admin-login-card">
        <div className="lead-dialog-eyebrow">Admin Access</div>
        <h1 className="lead-dialog-title" style={{ fontSize: 40, marginTop: 4, marginBottom: 12 }}>
          Sign in to the <em>Utsah dashboard.</em>
        </h1>
        <p className="lead-dialog-sub" style={{ marginBottom: 32 }}>
          Only allow-listed Google accounts can access captured leads and update the impact counter.
        </p>

        {user && !user.is_admin ? (
          <>
            <p
              className="admin-notice"
              data-testid="admin-not-authorised"
              style={{
                background: "#FDE8D0",
                color: "#A63F0E",
                padding: "14px 16px",
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 600,
                lineHeight: 1.5,
                marginBottom: 20,
              }}
            >
              Signed in as <strong>{user.email}</strong>, but this account is not on the admin allow-list. Ask the site owner to add your email to <code>ADMIN_EMAILS</code>.
            </p>
            <button
              type="button"
              className="lead-submit"
              onClick={goLogin}
              data-testid="admin-login-button"
              style={{ width: "100%" }}
            >
              Try a different Google account
            </button>
          </>
        ) : (
          <button
            type="button"
            className="lead-submit"
            onClick={goLogin}
            data-testid="admin-login-button"
            style={{ width: "100%" }}
          >
            Continue with Google
          </button>
        )}
      </div>
    </div>
  );
}
